<template>
  <div class="tab-content">
    <div class="supervision-data-section">
      <a-form layout="vertical">
        <!-- 第一部分：接入方式 -->
        <div class="form-section">
          <h3 class="section-subtitle">接入方式</h3>
          <div class="form-item">
            <label class="form-label">接入协议：</label>
            <a-select 
              v-model:value="connectionConfig.protocol" 
              style="width: 200px;" 
              placeholder="请选择接入协议"
            >
              <a-select-option value="https">HTTPS</a-select-option>
              <a-select-option value="mqtt">MQTT</a-select-option>
              <a-select-option value="kafka">KAFKA</a-select-option>
              <a-select-option value="websocket">WebSocket</a-select-option>
            </a-select>
          </div>
          
          <div class="form-item">
            <label class="form-label">接入凭证：</label>
            <a-input 
              v-model:value="connectionConfig.credentials" 
              placeholder="请输入接入凭证" 
              style="width: 400px;"
              :type="showCredentials ? 'text' : 'password'"
              autocomplete="new-password"
            >
              <template #addonAfter>
                <a-button 
                  @click="toggleCredentialsVisibility"
                  type="text"
                >
                  {{ showCredentials ? '隐藏' : '显示' }}
                </a-button>
              </template>
            </a-input>
          </div>
        </div>
        
        <!-- 分隔线 -->
        <div class="section-divider"></div>
        
        <!-- 第二部分：接入数据 -->
        <div class="form-section">
          <h3 class="section-subtitle">接入数据</h3>
          <div class="form-item">
            <label class="form-label">车辆控制模式：</label>
            <div class="checkbox-group">
              <label class="checkbox-option">
                <input
                  type="checkbox"
                  value="auto"
                  :checked="dataConfig.controlMode.includes('auto')"
                  disabled
                />
                <span>自动驾驶</span>
              </label>
              <label class="checkbox-option">
                <input
                  type="checkbox"
                  value="manual"
                  :checked="dataConfig.controlMode.includes('manual')"
                  disabled
                />
                <span>人工驾驶</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">车辆位置信息：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="realTimeLocation"
                  value="1"
                  v-model="dataConfig.realTimeLocation"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="realTimeLocation"
                  value="0"
                  v-model="dataConfig.realTimeLocation"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">行驶里程：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="drivingMileage"
                  value="1"
                  v-model="dataConfig.drivingMileage"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="drivingMileage"
                  value="0"
                  v-model="dataConfig.drivingMileage"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">运动状态：</label>
            <div class="checkbox-group">
              <label class="checkbox-option" v-for="status in motionStatusOptions" :key="status.value">
                <input
                  type="checkbox"
                  :value="status.value"
                  :checked="dataConfig.motionStatus.includes(status.value)"
                  disabled
                />
                <span>{{ status.label }}</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">车辆标识信息：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="vehicleIdentity"
                  value="1"
                  v-model="dataConfig.vehicleIdentity"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="vehicleIdentity"
                  value="0"
                  v-model="dataConfig.vehicleIdentity"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">远程控制指令：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="remoteControl"
                  value="1"
                  v-model="dataConfig.remoteControl"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="remoteControl"
                  value="0"
                  v-model="dataConfig.remoteControl"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">视频监控：</label>
            <div class="checkbox-group">
              <label class="checkbox-option" v-for="camera in cameraOptions" :key="camera.value">
                <input
                  type="checkbox"
                  :value="camera.value"
                  :checked="dataConfig.cameraPositions.includes(camera.value)"
                  disabled
                />
                <span>{{ camera.label }}</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">环境感知：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="environmentPerception"
                  value="1"
                  v-model="dataConfig.environmentPerception"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="environmentPerception"
                  value="0"
                  v-model="dataConfig.environmentPerception"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">灯光信号状态：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="lightStatus"
                  value="1"
                  v-model="dataConfig.lightStatus"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="lightStatus"
                  value="0"
                  v-model="dataConfig.lightStatus"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">故障信息：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input
                  type="radio"
                  name="faultWarning"
                  value="1"
                  v-model="dataConfig.faultWarning"
                  disabled
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input
                  type="radio"
                  name="faultWarning"
                  value="0"
                  v-model="dataConfig.faultWarning"
                  disabled
                />
                <span>否</span>
              </label>
            </div>
          </div>
          
          <div class="form-item">
            <label class="form-label">行驶轨迹：</label>
            <div class="radio-group">
              <label class="radio-option">
                <input 
                  type="radio" 
                  name="drivingTrack" 
                  value="1" 
                  v-model="dataConfig.drivingTrack"
                />
                <span>是</span>
              </label>
              <label class="radio-option">
                <input 
                  type="radio" 
                  name="drivingTrack" 
                  value="0" 
                  v-model="dataConfig.drivingTrack"
                />
                <span>否</span>
              </label>
            </div>
          </div>
        </div>
        
        <!-- 分隔线 -->
        <div class="section-divider"></div>
        
        <!-- 第三部分：监管数据接入证明 -->
        <div class="form-section">
          <h3 class="section-subtitle">监管数据接入证明</h3>
          <div class="form-item">
            <div class="pl64">
              <div v-if="fileList.length > 0" class="uploaded-files">
                <div
                  v-for="(file, index) in fileList"
                  :key="index"
                  class="file-item">
                  <span class="file-icon">📄</span>
                  <span class="file-name">{{ file.name }}</span>
                  <a class="preview-btn" @click="handleFilePreview(file)">预览</a>
                </div>
              </div>
              <div v-else class="no-file-tip">
                暂无上传文件
              </div>
            </div>
          </div>
        </div>

        <!-- 文件预览抽屉 -->
        <FilePreview
            v-model:visible="previewVisible"
            :file-url="previewFileUrl"
            :file-name="previewFileName"
            @close="handlePreviewClose"
        />
        
        <!-- 操作按钮区域 -->
        <!-- <div v-if="userTaskPermissionList.includes('supervise_access')" class="form-actions">
          <a-button type="primary" @click="handleSave">
            保存
          </a-button>
        </div> -->
      </a-form>
    </div>
  </div>
</template>

<script setup name="SupervisionDataTab">
import { defineProps, ref, reactive, onMounted, defineEmits } from 'vue';
import { message } from 'ant-design-vue';
import FilePreview from '@/components/FilePreview/index.vue';
import { applicationSuperviseAccess } from "@/api/application/applicationSupervise";

// 定义组件接收的props
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  userTaskPermissionList: {
    type: Array
  },
  editType: {
    type: Boolean,
    default: false
  }
});

// 定义事件
const emit = defineEmits(['upload-application-info']);

// 接入配置数据
const connectionConfig = reactive({
  protocol: 'mqtt',
  credentials: ''
});

// 接入数据配置
const dataConfig = reactive({
  controlMode: ['auto', 'manual'],
  realTimeLocation: '1',
  drivingMileage: '1',
  motionStatus: ['speed', 'acceleration', 'direction', 'headingAngle', 'brakeStatus', 'steeringAngle', 'gearPosition', 'angularVelocity'],
  vehicleIdentity: '1',
  remoteControl: '1',
  cameraPositions: ['front', 'rear', 'left', 'right'],
  environmentPerception: '1',
  lightStatus: '1',
  faultWarning: '1',
  drivingTrack: ''
});

// 视频摄像头选项
const cameraOptions = [
  { label: '前方', value: 'front' },
  { label: '后方', value: 'rear' },
  { label: '左侧', value: 'left' },
  { label: '右侧', value: 'right' }
];

// 运动状态选项
const motionStatusOptions = [
  { label: '速度', value: 'speed' },
  { label: '加速度', value: 'acceleration' },
  { label: '行驶方向', value: 'direction' },
  { label: '正向行驶方向角', value: 'headingAngle' },
  { label: '制动状态', value: 'brakeStatus' },
  { label: '转向角度', value: 'steeringAngle' },
  { label: '档位信息', value: 'gearPosition' },
  { label: '角速度', value: 'angularVelocity' }
];

// 凭证显示控制
const showCredentials = ref(false);

// 证明文件
const proofFile = ref('https://testing-management-private.obs.cn-southwest-2.myhuaweicloud.com/testing-management-private/material/1786507141758/低速无人驾驶车辆(装备)监管数据接入证明_1786507142270.pdf');

// 上传文件列表
const fileList = ref([
  {
    name: '低速无人驾驶车辆(装备)监管数据接入证明_1786507142270.pdf',
    url: 'https://testing-management-private.obs.cn-southwest-2.myhuaweicloud.com/testing-management-private/material/1786507141758/低速无人驾驶车辆(装备)监管数据接入证明_1786507142270.pdf'
  }
]);

// 文件预览
const previewVisible = ref(false);
const previewFileUrl = ref('');
const previewFileName = ref('');

const handleFilePreview = (file) => {
  if (file && file.url) {
    previewFileUrl.value = file.url;
    previewFileName.value = file.name || '文件预览';
    previewVisible.value = true;
  }
};

const handlePreviewClose = () => {
  previewVisible.value = false;
};

// 切换凭证可见性
const toggleCredentialsVisibility = () => {
  showCredentials.value = !showCredentials.value;
};

// 下载证明文件
const downloadProofFile = () => {
  if (proofFile.value) {
    // 实际应用中应该调用下载API
    window.location.href = `/api/download?file=${proofFile.value}`;
  }
};

// 保存配置
const handleSave = async () => {
  try {
    // 实际应用中应该调用API保存配置
    const data = {
      applicationId: props.id,
    }
    const res = await applicationSuperviseAccess(data)
    if (res.code === 200){
      message.success('保存成功');
      emit('update-application-info');
    }
  } catch (error) {
    console.error('保存失败:', error);
    message.error('保存失败，请稍后重试');
  }
};

// 获取应用信息和监管数据配置
const fetchSupervisionDataConfig = async () => {
  try {
    // 实际应用中应该调用API获取数据
    console.log('获取监管数据配置，应用ID:', props.id);
    
    // 模拟API请求延迟
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // 模拟数据 - 实际应用中应该从API获取
    connectionConfig.protocol = 'mqtt';
    connectionConfig.credentials = 'test_credential_123456';
    
    dataConfig.controlMode = ['auto', 'manual'];
    dataConfig.realTimeLocation = '1';
    dataConfig.drivingMileage = '1';
    dataConfig.motionStatus = ['speed', 'acceleration', 'direction', 'headingAngle', 'brakeStatus', 'steeringAngle', 'gearPosition', 'angularVelocity'];
    dataConfig.vehicleIdentity = '1';
    dataConfig.remoteControl = '1';
    dataConfig.cameraPositions = ['front', 'rear', 'left', 'right'];
    dataConfig.environmentPerception = '1';
    dataConfig.lightStatus = '1';
    dataConfig.faultWarning = '1';
    dataConfig.drivingTrack = '';
    
  } catch (error) {
    console.error('获取监管数据配置失败:', error);
    message.error('获取数据失败，请稍后重试');
  }
};

// 组件挂载时获取数据
onMounted(async () => {
  await fetchSupervisionDataConfig();
});
</script>

<style scoped lang="less">
.tab-content {
  background: #fff;
  padding: 0 20px;
  margin-bottom: 80px;
}

.supervision-data-section {
  background: #fff;
  border-radius: 6px;
  padding: 12px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section {
  margin-bottom: 12px;
}

.section-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 12px 0;
}

.section-subtitle {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}

.form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  padding: 0 12px;
}

.form-label {
  width: 150px;
  font-size: 14px;
  color: #666;
  text-align: right;
  padding-right: 16px;
  flex-shrink: 0;
  padding-top: 6px;
}

.radio-group {
  display: flex;
  gap: 24px;
  padding-top: 6px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.radio-option input[type="radio"] {
  cursor: pointer;
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 6px;
}

.checkbox-option {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.checkbox-option input[type="checkbox"] {
  cursor: pointer;
}

.file-actions {
  display: flex;
  align-items: center;
}

.upload-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.upload-hint {
  margin: 0;
  color: #999;
  font-size: 12px;
}

.form-actions {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  margin-top: 16px;
}

.uploaded-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  transition: all 0.3s;
  width: fit-content;

  &:hover {
    background: #e6f7ff;
    border-color: #1890ff;
  }

  .file-icon {
    margin-right: 8px;
    font-size: 16px;
  }

  .file-name {
    font-size: 14px;
    color: #333;
    margin-right: 12px;
  }

  .preview-btn {
    color: #1890ff;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      color: #40a9ff;
    }
  }
}

.no-file-tip {
  color: #999;
  font-size: 14px;
  padding: 8px 0;
}

.pl64 {
  padding-left: 64px;
}
</style>